var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { CheckIcon } from '../icons/index.js';
import { runIfFn } from '../utils/index.js';
import { useMultiselect } from './MultiselectContext.js';
import { hasId } from './util.js';
export const MultiselectItem = forwardRef((props, ref) => {
    const { value, index, children, disabled, className } = props, rest = __rest(props, ["value", "index", "children", "disabled", "className"]);
    const { selectedItems, getItemProps, highlightedIndex } = useMultiselect();
    let selected;
    if (hasId(value)) {
        selected = selectedItems.some(it => hasId(it) && it.id === value.id);
    }
    else {
        selected = selectedItems.includes(value);
    }
    const active = highlightedIndex === index;
    return (React.createElement("li", Object.assign({ className: clsx(active
            ? 'bg-action-primary text-content-on-primary'
            : 'bg-surface text-content', 'cursor-default select-none relative py-2 ps-3 pe-9', className) }, getItemProps(Object.assign({ ref, item: value, index, disabled }, rest))),
        React.createElement(React.Fragment, null,
            React.createElement("span", { className: clsx(selected ? 'font-semibold' : 'font-normal', disabled ? 'opacity-50' : '', 'block truncate') }, runIfFn(children, {
                selected,
                active,
            })),
            selected ? (React.createElement("span", { className: clsx(active ? 'text-content-on-primary' : 'text-content-subdued', 'absolute inset-y-0 end-0 flex items-center pe-4') },
                React.createElement(CheckIcon, { className: "h-5 w-5", "aria-hidden": "true" }))) : null)));
});
//# sourceMappingURL=MultiselectItem.js.map